export function getRentalApplicationTerm() {
  return {
    rental_application_term: {
      displayed_button_txt: null,
      interaction_button_txt: null,
    },
  };
}
